import { Link } from "react-router-dom";

export default function Logo({ testid = "header-logo", imgClass = "h-12 sm:h-14" }) {
    return (
        <Link
            to="/"
            data-testid={testid}
            aria-label="Pacific Expressway — home"
            className="flex items-center shrink-0"
        >
            <img
                src="/logo.png"
                alt="Pacific Expressway"
                width="831"
                height="436"
                className={`${imgClass} w-auto`}
            />
        </Link>
    );
}
